var map = {
	"./chosen.js": 2,
	"./datapicker.js": 5,
	"./justified-gal.js": 7,
	"./magnific-popup.js": 9,
	"./slider.js": 10,
	"./svg.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



//////////////////
// WEBPACK FOOTER
// ./js/components/plugins ^(.*\.(js$))[^.]*$/gi
// module id = 1
// module chunks = 0